<script lang="ts" setup>
import { computed, ref } from 'vue'

interface Props {
  rows?: string | number
  disabled?: boolean
  error?: boolean
  placeholder?: string
}

const model = defineModel<string | null>({ required: true })

const props = withDefaults(defineProps<Props>(), {
  rows: '4',
  disabled: false,
})

const inputClass = computed(() => ({
  'border-neutral-300 dark:border-neutral-700': !props.error,
  'border-danger-300 dark:border-danger-700': props.error,
}))

const textarea = ref<HTMLTextAreaElement | null>(null)

const focus = () => {
  textarea.value?.focus()
}

defineExpose({
  focus,
})

// onMounted(() => {
//   textarea.value?.focus()
// })
</script>
<template>
  <div class="p-0">
    <textarea
      ref="textarea"
      :rows="rows"
      :placeholder="placeholder"
      class="px-3 py-2 bg-white border-1 dark:bg-neutral-600block w-full rounded-md shadow-xs focus:border-primary-500 focus:ring-1 focus:ring-primary-200 dark:focus:border-primary-800 dark:focus:ring-primary-800 sm:text-sm disabled:cursor-not-allowed disabled:opacity-75 disabled:bg-neutral-100 dark:bg-neutral-950 dark:text-neutral-200"
      :class="inputClass"
      v-model="model"
      :disabled="disabled"
    />
  </div>
</template>
